import Vue from 'vue';
import Router from 'vue-router';
import  store  from '@/store/index';

import { asyncRouterMap, constantRouterMap } from '@/router/index';
import { permissionGroupgetRouters } from "@/api/permission";
import { getToken } from '@/utils/auth'

/* layout */
import Layout from '@/views/layout/Layout';
// const _import = require('./_import_' +  process.env.NODE_ENV);
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.role) {
    return roles.some(role => route.meta.role.indexOf(role) >= 0)
  } else {
    return true
  }
}

/**
 * 后台查询的菜单数据拼装成路由格式的数据
 * @param routes (resolve: any) => require([`@/views/${view}.vue`], resolve)
 */
export function generaMenu(routes, data) {
  data.forEach(item => {
    // 这里的字段在实际业务开发中都有用的，当然如果只是简单学习的话，id，label可以移除
    const menu = {
      id: item.id,
      label: item.label,
      name: item.name,
      path: item.path,
      component: item.component == 'Layout' ? Layout : (resolve) => require([`@/views/${item.component}`], resolve),
      redirect: item.redirect,
      hidden: !item.isShow,
      alwaysShow: item.alwaysShow,
      meta: item.meta,
      icon:item.icon,
      children: [],
      noDropdown:!item.isDropDown,
      // hidden:false,
    }
    if (item.children) {
      generaMenu(menu.children, item.children)
    }
    routes.push(menu)
  })
}
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    functionCodeList:[]
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    SET_FUCNTIONCODES:(state, functionCodes) => {
      state.functionCodeList = functionCodes
    }
  },
  actions: {
    GenerateRoutes({ commit }, roles) {
      return new Promise(resolve => {
        const loadMenuData = []
        permissionGroupgetRouters(getToken()).then(response => {
          let data = response
          // if (response.data != []) {
          //   throw new Error('菜单数据加载异常')
          // }
          // else {
          data = response.data.routers
          Object.assign(loadMenuData, data)
          const tempAsyncRoutes = Object.assign([], asyncRouterMap)
          // tempAsyncRoutes = asyncRoutes
          generaMenu(tempAsyncRoutes, loadMenuData)
          let accessedRoutes
          // if (roles.includes('super') >= 0) {
          //   accessedRoutes = tempAsyncRoutes || []
          // } else {
          accessedRoutes = filterAsyncRoutes(tempAsyncRoutes, roles)
          //  }
          commit('SET_ROUTERS', accessedRoutes)
          commit('SET_FUCNTIONCODES', response.data.functionCodes)
          resolve(accessedRoutes)
          //  }
        }).catch(error => {
          console.log(error)
        })
        //   let accessedRouters
        //   if (roles.indexOf('super') >= 0) {
        //     accessedRouters = asyncRouterMap
        //   } else {
        //     accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        //   }
        //   commit('SET_ROUTERS', accessedRouters);
        //   resolve();
      })
    }
  }
};
console.log(permission,"quanxaun")
export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js